import React, { useEffect, useState } from 'react'
import logo from '../photos/logo.png'
import '../styles/footer.css'
import { FaSquareFacebook, FaSquareGithub, FaLinkedin, FaSquareXTwitter } from 'react-icons/fa6'
import { FaInstagramSquare } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import ThemeToggle from './extra/ToggleTheme'

function Foot() {
    const [thisYear, setThisYear] = useState(new Date().getFullYear())


    return (
        <div className='footer'>
            <Link to='/' className="footer_left"><img src={logo} className='footer_logo' alt="logo" /></Link>
<ThemeToggle/>
            <div className="footer_right">
                <div className="footer_right-top">
                    <span> &copy; Shuaib N. Olawale,</span><span>alias  SNOTAT, {thisYear}.</span> </div>
                <div className="footer_right-bottom">
                    {/* <Link to="https://facebook.com/snotat" target="_blank" rel="noopener noreferrer"><FaSquareFacebook className='foot_icon' /></Link> */}
                    <Link to='https://x.com/snotat_' target="_blank" rel="noopener noreferrer"><FaSquareXTwitter className='foot_icon' /></Link>
                    <Link to='https://github.com/snotat' target="_blank" rel="noopener noreferrer"><FaSquareGithub className='foot_icon' /></Link>
                    <Link to='https://linkedin.com/in/snotat' target="_blank" rel="noopener noreferrer"> <FaLinkedin className='foot_icon' /></Link>  
                    {/* <Link to='https://instagram.com/_snotat' target="_blank" rel="noopener noreferrer"><FaInstagramSquare className='foot_icon' /></Link> */}
                </div>
            </div>
        </div>
    )
}

export default Foot
